import { DataModel } from "common/models/utility-models/base-model"

export class TrainersModel extends DataModel {
    first_name: any = ''
    last_name: any = ''
    email: any = ''
    mobile_number: any = ''
    categoryIds: any = ''
    override id: any = '';
    // user_id: any ='';
  }